import React, { useState } from "react";

import DatasetView from "components/dashboard/dataset-window/DatasetView";
import { Dataset } from "components/dashboard/dataset-window/models/types";
import { removeItemById } from "components/dashboard/dataset-window/utils/utils";
import { DatasetInfo, Maybe } from "gql/generated/types";
import { ListBox } from "primereact/listbox";
import { CurrentLineConfig } from "components/dashboard/dataset-window/DatasetLineConfigOptions";

type DatasetsTabProps = {
  datasets: Maybe<DatasetInfo>[] | undefined;
}

const DatasetsTab: React.FC<DatasetsTabProps> = ({ datasets }) => {
  const formattedData: Dataset[] = datasets?.map(dataset => ({
    identifier: dataset?.identifier ?? "",
    formatedTitle: dataset?.title ?? "",
    group: dataset?.groupTitle ?? "",
    title: dataset?.title ?? "",
    unit: dataset?.unit ?? "",
  })) ?? [];
  
  const [selectedDatasets, setSelectedDatasets] = useState<Dataset[]>(formattedData.slice(0, 15));

  if (!datasets || datasets?.length === 0) return <span className="mt-3 ml-3">No datasets are linked</span>;
  
  const removeDataset = (removedId: string) => {
      setSelectedDatasets(removeItemById(selectedDatasets, removedId))
  }

  const setCurrentLineConfig = (identifier: string, currentLineConfig: CurrentLineConfig) => {
    const newSelectedDatasets = selectedDatasets.map(dataset => {
      if (dataset.identifier === identifier) {
        return { ...dataset, currentLineConfig };
      }
      return dataset;
    });
    setSelectedDatasets(newSelectedDatasets);
  };

  return (
    <div className="w-full mt-3 flex" style={{ minHeight: "700px" }}>
      <ListBox
        value={selectedDatasets}
        options={formattedData ?? []}
        onChange={e => setSelectedDatasets(e.value)}
        placeholder="Datasets"
        optionLabel="title"
        className="p-inputtext-sm m-2"
        multiple
        filter
      />
      <DatasetView
        selectedDatasetsID={selectedDatasets}
        removeDataset={removeDataset}
        setSelectedDatasets={setSelectedDatasets}
        initialChart="RAW"
        setCurrentLineConfig={setCurrentLineConfig}
      />
    </div>
  );
}

export default DatasetsTab;